import { css, type Theme } from "@emotion/react";

export const card = (theme: Theme) => css`
  display: flex;
  flex-direction: column;
  gap: ${theme.ds5.gap[300]};
  background-color: ${theme.ds5.surface.level0};
  border: ${theme.ds5.box.borderWeight} solid ${theme.ds5.neutral.divider};
  border-radius: ${theme.ds5.radius.surface.xlarge};
  padding: ${theme.ds5.padding.static[600]};
`;
